export default __webpack_public_path__ + "static/media/exit.5494e143.svg";